<template>
  <div class="app light-mode">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    // 添加HTML属性强制浅色模式
    document.documentElement.setAttribute('data-theme', 'light');
    document.documentElement.style.colorScheme = 'light';
    // 禁用系统的暗色模式媒体查询
    this.disableDarkMode();
  },
  methods: {
    disableDarkMode() {
      // 创建一个覆盖系统暗色模式的样式
      const style = document.createElement('style');
      style.textContent = `
        @media (prefers-color-scheme: dark) {
          :root {
            color-scheme: light !important;
          }
        }
      `;
      document.head.appendChild(style);
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&display=swap');

:root {
  color-scheme: light;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* 强制浅色模式样式 */
.light-mode {
  --text-color: #333;
  --background-color: #f8f9fe;
  --card-background: white;
}

body {
  font-family: 'Poppins', 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--text-color, #333);
  line-height: 1.6;
  background-color: var(--background-color, #f8f9fe);
  forced-color-adjust: none;
}

.app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section {
  padding: 80px 0;
}

.btn {
  display: inline-block;
  padding: 15px 30px;
  border-radius: 50px;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  font-size: 1rem;
}

.btn-primary {
  background: linear-gradient(45deg, #FF6B8B 0%, #FF8E53 100%);
  color: white;
  box-shadow: 0 10px 20px rgba(255, 107, 139, 0.3);
}

.btn-primary:hover {
  transform: translateY(-3px);
  box-shadow: 0 15px 25px rgba(255, 107, 139, 0.4);
}

.btn-secondary {
  background: rgba(255, 255, 255, 0.2);
  color: #6C63FF;
  border: 2px solid #6C63FF;
}

.btn-secondary:hover {
  background: rgba(108, 99, 255, 0.1);
  transform: translateY(-3px);
}

.shape {
  position: absolute;
  z-index: -1;
}

.shape-star {
  width: 30px;
  height: 30px;
  color: white;
}

.shape-circle {
  width: 20px;
  height: 20px;
  background: #FFC847;
  border-radius: 50%;
}

.shape-square {
  width: 20px;
  height: 20px;
  background: #FF6B8B;
  transform: rotate(45deg);
}

.gradient-text {
  background: linear-gradient(45deg, #6C63FF, #FF6B8B);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  display: inline-block;
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
}

.section-header h2 {
  font-size: 2.5rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 20px;
  position: relative;
  display: inline-block;
}

.section-header p {
  font-size: 1.1rem;
  color: #666;
  max-width: 700px;
  margin: 0 auto;
}
</style>
